// extracted by mini-css-extract-plugin
module.exports = {"layout":"post-wrapper_layout__2Z0Jx","borderBottom":"post-wrapper_borderBottom__Jr-Zw"};